import axios from "axios";

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.common['X-CSRF-TOKEN'] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content');

export class ConstructionWork {
    async initData() {
        const res = await axios.get("/construction-work/init-data");
        return res.data;
    }

    async fetchConstructionWorkMap() {
        const res = await axios.get("/construction-work/map");
        return res.data;
    }

    async fetchSelectedIncidents(ids: number[]) {
        const res = await axios.get("/incident/map/ajax-selected-incidents", {
            params: {
                ids
            }
        });
        return res.data;
    }

    async fetchSelectedConstructionWorks(ids: string[]) {
        const res = await axios.get("/construction-work/map/ajax-selected-works", {
            params: {
                ids
            }
        });
        return res.data;
    }

    async getFilteredWorks(filters: any, page: number = 1) {
        const params = new URLSearchParams();

        // Добавляем параметр страницы
        params.append('page', String(page));

        // Преобразуем фильтры в GET параметры
        for (const [key, values] of Object.entries(filters)) {
            if (key === 'sorting') {
                // Для sorting передаем как JSON-строку, как в PHP API
                if (Array.isArray(values) && values.length > 0) {
                    params.append(key, JSON.stringify(values));
                }
            } else if (Array.isArray(values) && values.length > 0) {
                values.forEach(value => {
                    params.append(`${key}[]`, value);
                });
            } else if (values !== null && values !== undefined && values !== '') {
                // Для не-массивов (например, type)
                params.append(key, String(values));
            }
        }

        const queryString = params.toString();
        const url = queryString ? `/construction-work/filter?${queryString}` : `/construction-work/filter?page=${page}`;

        const res = await axios.get(url);
        return res.data;
    }

    async readAll() {
        await axios.post('/construction-work/read-all');
    }
}

const ConstructionWorkApi = new ConstructionWork();

export { ConstructionWorkApi };
